import { createI18n } from "vue-i18n"

import en from "@/translations/en.json"
import ru from "@/translations/ru.json"
// import fr from "@/translations/fr.json"
// import ge from "@/translations/ge.json"
// import ch from "@/translations/ch.json"
// import sp from "@/translations/sp.json"

type MessageSchema = typeof en
const i18n = createI18n<[MessageSchema], "en" | "ru">({
  // | "fr" | "ge" | "ch" | "sp"
  //   legacy: false, // Use Composition API if true
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en,
    ru,
    // fr,
    // ge,
    // ch,
    // sp,
  },
})

export default i18n
